import { isValidString } from '@contexts/shared/domain';

export function parseCsvText<T, R extends Record<string, unknown>>(
	csvText: string,
	requiredColumns: (keyof R)[],
	createObject: (record: R) => T | null | undefined
): T[] {
	const lines = csvText.trim().split('\n');
	const [headerLine, ...dataLines] = lines;
	const headers = headerLine.split(',').map((header) => header.trim());

	if (!validateCsvHeaders(requiredColumns as string[], headers)) {
		throw new Error(INCORRECT_COLUMNS_ERROR);
	}

	const records = dataLines.reduce<T[]>((acc, dataLine) => {
		const values = parseEmptyCsvValues(parseCsvLine(dataLine));

		const record = Object.fromEntries(
			headers.map((header, index) => [header, values[index]])
		) as unknown as R;

		const newItem = createObject(record);

		if (newItem) {
			acc.push(newItem);
		}

		return acc;
	}, []);

	return records;
}

const INCORRECT_COLUMNS_ERROR =
	'Por favor, comprueba que los nombres de todas las columnas sean correctos y que no falte ni sobre ninguna columna.';

function validateCsvHeaders(requiredColumns: string[], headers: string[]): boolean {
	const missingColumns = requiredColumns.filter((col) => !headers.includes(col));
	const extraColumns = headers.filter((col) => !requiredColumns.includes(col));

	if (missingColumns.length > 0 || extraColumns.length > 0) {
		return false;
	}

	return true;
}

export function parseCsvLine(line: string): string[] {
	return line.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map((val) => {
		let value = val.trim();
		if (value.startsWith('"') && value.endsWith('"')) {
			value = value.substring(1, value.length - 1).replace(/""/g, '"');
		}
		return value;
	});
}

function parseEmptyCsvValues<T>(values: T[]): (T | null)[] {
	return values.map((value) => (isValidString(value) ? value : null));
}
